import React from 'react';
import { ErrorMessage, Header3Text, Header4Text, ModalWindow, SwitchDialogWindows } from 'ui-toolkit';
import { UUID } from '../../types/shared/UUID';
import { IConversationOrderData } from '../../types/conversations/IConversation';
import { EditConversationContainer } from './EditConversationContainer';
import { useSelector } from 'react-redux';
import { saveConversationAction } from '../../store/conversations/saveConversationSlice';
import { eContactType } from '../../types/conversations/eContactType';
import { SaveConversationStatusModal } from './SaveConversationStatusModal';
import { RootStore } from '../../store/types';
import { useAppDispatch } from '../../store/store';

export interface IEditConversationOrderModalContainerProps {
  conversationOrder: IConversationOrderData;
  orderId?: UUID;
  onClose: () => void;
}

export const EditConversationOrderModal: React.FC<IEditConversationOrderModalContainerProps> = ({
  conversationOrder,
  onClose,
}) => {
  const dispatch = useAppDispatch();

  const { saveConversation } = useSelector((state: RootStore) => state.conversations);
  const { fetchStatus, fetchError } = saveConversation;

  const onSubmit = (formData: IConversationOrderData) => {
    if (conversationOrder?.genesysId) {
      dispatch(
        saveConversationAction({
          id: formData.genesysId,
          contactId: formData.contact ? formData.contact.id : undefined,
          contactType: formData.contact ? formData.contact.contactType : eContactType.None,
          orderId: formData.orderId,
        })
      );
    }
  };

  return (
    <SwitchDialogWindows
      isLoading={fetchStatus.fetching}
      isCompleted={fetchStatus.fetched}
      isError={!!fetchError}
      errorTitle={<Header3Text>There was an error saving this conversation link</Header3Text>}
      loadingTitle="Saving Conversation Link..."
      successTitle="Conversation Link was saved."
      errorMessage={<ErrorMessage error={fetchError} />}
      onCloseClick={() => {
        if (!fetchStatus.fetching) onClose();
      }}
    >
      <ModalWindow title={<Header4Text>Link conversation to another order</Header4Text>} onClose={onClose}>
        <EditConversationContainer
          conversationId={conversationOrder.genesysId}
          onCancel={onClose}
          onSubmit={onSubmit}
          saveButtonText={'Confirm'}
        />
        {fetchStatus.fetched && (
          <SaveConversationStatusModal fetchStatus={fetchStatus} fetchError={fetchError} close={onClose} />
        )}
      </ModalWindow>
    </SwitchDialogWindows>
  );
};
